var _path, _path2, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLicense = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  stroke: "#26A69A",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  className: "license_svg__feather license_svg__feather-pen-tool"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m12 19 7-7 3 3-7 7z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "m18 13-1.5-7.5L2 2l3.5 14.5L13 18zM2 2l7.586 7.586"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 11,
  cy: 11,
  r: 2
})));
export { SvgLicense as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiBmaWxsPSJub25lIiBzdHJva2U9IiMyNkE2OUEiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBjbGFzcz0iZmVhdGhlciBmZWF0aGVyLXBlbi10b29sIj48cGF0aCBkPSJNMTIgMTlsNy03IDMgMy03IDctMy0zeiI+PC9wYXRoPjxwYXRoIGQ9Ik0xOCAxM2wtMS41LTcuNUwyIDJsMy41IDE0LjVMMTMgMThsNS01eiI+PC9wYXRoPjxwYXRoIGQ9Ik0yIDJsNy41ODYgNy41ODYiPjwvcGF0aD48Y2lyY2xlIGN4PSIxMSIgY3k9IjExIiByPSIyIj48L2NpcmNsZT48L3N2Zz4=";